import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ModernTemplateEditor from '../templateEditor/components/ModernEditor/ModernTemplateEditor';

// Import types from the dedicated types file to avoid circular imports
export type { TemplateEditorConfig, TemplateEditorProps } from '../templateEditor/types/editor';

// Simple wrapper component that exports the ModernTemplateEditor
const TemplateEditor: React.FC<any> = (props) => {
  const location = useLocation();
  const [initialData, setInitialData] = useState<any>(null);
  const [templateId, setTemplateId] = useState<string | undefined>(undefined);

  useEffect(() => {
    // Check if template data was passed via navigation state
    const state = location.state as any;
    if (state?.templateData) {
      console.log('📝 Loading template from navigation state:', state.templateId);
      setInitialData(state.templateData);
      setTemplateId(state.templateId);
    }
  }, [location.state]);

  // Default to template context if not specified
  const contextProps = {
    context: 'template' as const,
    initialData: initialData || props.initialData,
    templateId: templateId || props.templateId,
    ...props
  };

  return (
    <div className="flex flex-col overflow-hidden" style={{ height: 'calc(100vh - 64px)' }}>
      <ModernTemplateEditor {...contextProps} />
    </div>
  );
};

// Export as both named and default export to satisfy different import patterns
export { TemplateEditor };
export default TemplateEditor;
